import { useCallback } from 'react';
import { getContractById } from './contractHelper';
import { useContracts } from './useContracts';

export const useGetContract = () => {
  const { contracts } = useContracts();
  return useCallback(
    (contractId = '') => {
      return getContractById(contractId, contracts);
    },
    [contracts]
  );
};
